<template>
    
    <div class="notification alert" :class="classes">
        <div class="media">
            <icon :icon="icon" />
            <div class="media-body">
                {{notification.message}}
            </div>
        </div>



    </div>
</template>


<script>

import Icon from "../ui/Icon";

export default {
    props: ['notification'],
    data(){
        return {

        }
    },
    computed: {
        classes(){
            let css = [];
            switch(this.notification.type){
                case 'error': css.push('alert-danger');  break;
                case 'success': css.push('alert-success');  break;
                case 'warning': css.push('alert-warning');  break;
            }
            return css.join(' ');
        },
        icon(){
            let iconName = '';
            switch(this.notification.type){
                case 'error'  : iconName = 'times';  break;
                case 'success': iconName = 'check';  break;
                case 'warning': iconName = 'exclamation-triangle';  break;
            }
            return iconName
        }
    },
    components: {
        Icon
    }
}
</script>

<style lang="sass">
    .alert.alert-danger,
    .alert.alert-success,
    .alert.alert-warning
        background-color: transparent
        background: linear-gradient(0, #F9F9F9, #FFFFFF)
        border-color: #CCC
        border-radius: 5px
        margin: 0 0 .5em 0
        text-align: left
        color: #333333
        font-size: .9em
        width: 100%
        box-shadow: 0 2px 2px rgba(0,0,0,.4)

    .alert svg
        margin-right: .5em
        font-size: 22px

    .alert.alert-danger svg
        color: #CA3839

    .alert.alert-success svg
        color: #89C664

    .alert.alert-warning svg
        color: #FCD758



</style>



// WEBPACK FOOTER //
// src/components/layout/Notification.vue